import './profile.scss';
import { UserProfile, useDescope, useUser } from '@descope/react-sdk';
import React, { useCallback, useState } from 'react';
import { Descope } from '@descope/react-sdk';

const Profile = () => {
  const { logout } = useDescope();
  const { user } = useUser();
  const [isSteppedUp, setIsSteppedUp] = useState(false); // Track if step-up is successful

  const logoutUser = useCallback(async () => {
    logout();
  }, [logout]);

  const handleStepUpSuccess = (e) => {
    console.log('Successfully stepped-up authentication!', e);
    setIsSteppedUp(true); // Allow rendering the profile widget after step-up
  };

  const handleStepUpError = (e) => {
    console.log('Could not step-up authentication!', e);
    setIsSteppedUp(false); // Prevent rendering the profile widget
  };

  return (
    <div className="data-table-wrapper">
      {!isSteppedUp ? (
        // Render the step-up flow if not yet authenticated
        <Descope
          flowId="step-up"
          onSuccess={handleStepUpSuccess}
          onError={handleStepUpError}
        />
      ) : (
        // Render the profile widget after successful step-up
        <div className="profile">
          <UserProfile
            widgetId="user-profile-widget"
            onLogout={logoutUser}
          />
        </div>
      )}
    </div>
  );
};

export default Profile;